module.exports = __webpack_public_path__ + "static/media/nutrition-fitness.255737c5.png";